import {
	GET_PAYMENT_OPTIONS_REQUEST,
	GET_PAYMENT_OPTIONS_SUCCESS,
	PAYMENT_OPTION_SUCCESS_AND_MODIFY_SELECTED_OPTION,
	GET_PAYMENT_OPTIONS_ERROR,
	RESET_PAYMENT_OPTIONS,
	VOUCHER_ADD_OR_SELECT_REQUEST,
	VOUCHER_ADD_OR_SELECT_SUCCESS,
	VOUCHER_ADD_OR_SELECT_ERROR,
	INSTRUMENT_CHECK_REQUEST,
	INSTRUMENT_CHECK_SUCCESS,
	INSTRUMENT_CHECK_ERROR,
	PAY_WITH_DETAILS_REQUEST,
	PAY_WITH_DETAILS_SUCCESS,
	PAY_WITH_DETAILS_ERROR,
	NET_OPTIONS_REQUEST,
	NET_OPTIONS_SUCCESS,
	NET_OPTIONS_ERROR,
	UPI_OPTIONS_REQUEST,
	UPI_OPTIONS_SUCCESS,
	UPI_OPTIONS_ERROR,
	EMI_BANKS_REQUEST,
	EMI_BANKS_SUCCESS,
	EMI_BANKS_ERROR,
	EMI_TENURES_REQUEST,
	EMI_TENURES_SUCCESS,
	EMI_TENURES_ERROR,
	PAY_REQUEST,
	PAY_SUCCESS,
	PAY_ERROR,
	EMI_TERMS_REQUEST,
	EMI_TERMS_SUCCESS,
	EMI_TERMS_ERROR,
	GET_CAPTCHA_REQUEST,
	GET_CAPTCHA_SUCCESS,
	GET_CAPTCHA_ERROR,
	EMI_CARDS_REQUEST,
	EMI_CARDS_SUCCESS,
	EMI_CARDS_ERROR,
	PAY_VIA_WALLET_REQUEST,
	PAY_VIA_WALLET_SUCCESS,
	PAY_VIA_WALLET_ERROR,
	OTP_MODES_REQUEST,
	OTP_MODES_SUCCESS,
	OTP_MODES_ERROR,
	OTP_SUBMIT_REQUEST,
	OTP_SUBMIT_SUCCESS,
	OTP_SUBMIT_ERROR,
	ADVANCE_PAYMENT_BREAKUP_ACTION_STATE,
	SELECT_INSTRUMENT_REQUEST_STATE,
	EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE,
	EMI_2FA_REQUEST,
	EMI_2FA_SUCCESS,
	EMI_2FA_ERROR,
	MOBILE_WALLET_OPTIONS_REQUEST,
	MOBILE_WALLET_OPTIONS_SUCCESS,
	MOBILE_WALLET_OPTIONS_ERROR,
	MOBILE_WALLET_OTP_LOADING,
	MOBILE_WALLET_OTP_SUCCESS,
	MOBILE_WALLET_OTP_ERROR
} from 'actions/PaymentActions/PaymentActions';
import { IPaymentTokenAction } from 'actions/paymentTokenActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';

const INITIAL_STATE = INIT;

export default function paymentAsyncStatus(state = INITIAL_STATE, action = {}) {
	// NOTE: we should show a loader from the point pay with details response
	// comes back until we redirect to bank page. so this block also contains a
	// SUCCESS type, and is intentional
	switch (action.type) {
		case GET_PAYMENT_OPTIONS_REQUEST:
		case VOUCHER_ADD_OR_SELECT_REQUEST:
		case INSTRUMENT_CHECK_REQUEST:
		case PAY_WITH_DETAILS_REQUEST:
		case NET_OPTIONS_REQUEST:
		case UPI_OPTIONS_REQUEST:
		case EMI_BANKS_REQUEST:
		case EMI_TENURES_REQUEST:
		case PAY_REQUEST:
		case EMI_TERMS_REQUEST:
		case GET_CAPTCHA_REQUEST:
		case EMI_CARDS_REQUEST:
		case PAY_VIA_WALLET_REQUEST:
		case OTP_MODES_REQUEST:
		case OTP_SUBMIT_REQUEST:
		case EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE.REQUEST:
		case ADVANCE_PAYMENT_BREAKUP_ACTION_STATE.REQUEST:
		case SELECT_INSTRUMENT_REQUEST_STATE.REQUEST:
		case EMI_2FA_REQUEST:
		case MOBILE_WALLET_OPTIONS_REQUEST:
		case MOBILE_WALLET_OTP_LOADING:
			return LOADING;

		case GET_PAYMENT_OPTIONS_SUCCESS:
		case VOUCHER_ADD_OR_SELECT_SUCCESS:
		case PAYMENT_OPTION_SUCCESS_AND_MODIFY_SELECTED_OPTION:
		case INSTRUMENT_CHECK_SUCCESS:
		case NET_OPTIONS_SUCCESS:
		case UPI_OPTIONS_SUCCESS:
		case EMI_BANKS_SUCCESS:
		case EMI_TENURES_SUCCESS:
		case PAY_WITH_DETAILS_SUCCESS:
		case PAY_SUCCESS:
		case EMI_TERMS_SUCCESS:
		case GET_CAPTCHA_SUCCESS:
		case EMI_CARDS_SUCCESS:
		case PAY_VIA_WALLET_SUCCESS:
		case OTP_MODES_SUCCESS:
		case OTP_SUBMIT_SUCCESS:
		case EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE.SUCCESS:
		case ADVANCE_PAYMENT_BREAKUP_ACTION_STATE.SUCCESS:
		case SELECT_INSTRUMENT_REQUEST_STATE.SUCCESS:
		case EMI_2FA_SUCCESS:
		case MOBILE_WALLET_OPTIONS_SUCCESS:
		case MOBILE_WALLET_OTP_SUCCESS:
			return SUCCESS;

		case GET_PAYMENT_OPTIONS_ERROR:
		case VOUCHER_ADD_OR_SELECT_ERROR:
		case INSTRUMENT_CHECK_ERROR:
		case PAY_WITH_DETAILS_ERROR:
		case NET_OPTIONS_ERROR:
		case UPI_OPTIONS_ERROR:
		case EMI_BANKS_ERROR:
		case EMI_TENURES_ERROR:
		case PAY_ERROR:
		case EMI_TERMS_ERROR:
		case GET_CAPTCHA_ERROR:
		case EMI_CARDS_ERROR:
		case PAY_VIA_WALLET_ERROR:
		case OTP_MODES_ERROR:
		case OTP_SUBMIT_ERROR:
		case EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE.ERROR:
		case ADVANCE_PAYMENT_BREAKUP_ACTION_STATE.ERROR:
		case SELECT_INSTRUMENT_REQUEST_STATE.ERROR:
		case EMI_2FA_ERROR:
		case MOBILE_WALLET_OPTIONS_ERROR:
		case MOBILE_WALLET_OTP_ERROR:
			return ERROR;

		case RESET_PAYMENT_OPTIONS:
		case IPaymentTokenAction.GET_PAYMENT_TOKEN_REQUEST:
			return INITIAL_STATE;

		default:
			return state;
	}
}
